import React, { useState, useRef, useEffect } from "react";
import { sendMessage } from "../../api/chatbotApi";
import "./ChatBox.css";
import LoadingMessage from "../general/LoadingMessage/LoadingMessage";
import ReactMarkdown from "react-markdown";
import navigatorIcon from "../../assets/icons/the-navigator-icon.png";
import like from "../../assets/icons/Like-icon.png";
import dislike from "../../assets/icons/Dislike-icon.png";
import { translations } from '../../utils/translations';
import { useParams } from "react-router-dom";
import getSessionCode from "../../utils/sessionCode";
import FeedbackLabels from "../feedback/feedbackLabels";
import serverConfig from "../../config/serverConfig";

const ChatBox = ({ closeChat, language }) => {

    // Session ID
    const sessionCode = getSessionCode();
    // Chat history messages
    const [messages, setMessages] = useState([]);
    // messages to be displayed
    const [messagesToDisplay, setMessagesToDisplay] = useState([]);
    // Input message from user
    const [input, setInput] = useState("");
    // Loading state
    const [isLoading, setIsLoading] = useState(false);
    // Reference to the bottom of the chat
    const messagesEndRef = useRef(null);
    // language panel
    const [showPanel, setShowPanel] = useState(true);
    // current language
    // Mapping from URL short codes to translation keys
    const LANG_MAP = { pt: "portuguese", en: "english", es: "spanish" };

    const [selectedLanguage, setSelectedLanguage] = useState(language || "pt");
    const t = translations[LANG_MAP[selectedLanguage] || selectedLanguage] || translations['portuguese'];

    // feedback
    const [activeFeedback, setActiveFeedback] = useState({}); // ou é 'like' ou 'dislike' ou null
    const [feedbackText, setFeedbackText] = useState("");
    const [feedbackReceived, setFeedbackReceived] = useState({}); // true or false for each LLM prompt

    // Greeting message from the chatbot
    const [greetingMessage, setGreetingMessage] = useState("");

    // Timestamp of the given feedback
    const [timeOfFeedback, setTimeOfFeedback] = useState(null);

    // to save the most recent response from the LLM
    const [recentResponse, setRecentResponse] = useState(null);

    // Remove global showFullAnswer, use per-message showFull property

    // Handle sending a message
    const handleSend = async () => {
    if (input.trim() === "") return;

    const userMessage = { content: input, role: 'user' };
    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setMessagesToDisplay((prevMessages) => [...prevMessages, userMessage]);
    setInput("");
    setIsLoading(true);
    try {
        const response = await sendMessage(input, messages, selectedLanguage);
        //const { simple, complex, url } = response.response;
        const answerText = response.answer; 
        setRecentResponse(answerText);
        const newMessages = [];

        // Timestamp for this specific assistant response
        const messageTimestamp = new Date().toISOString();
        // Handle simple message if present
        //if (simple && simple.trim() !== "") {
          //  const simpleMessage = {
          //      role: "assistant",
          //      short_answer: simple,
          //      full_answer: "",
          //      citations: [],
          //      showFull: false,
          //      showCitations: false,
          //      url: false,
          //      hideShortAnswer: false
          //  };
          //  newMessages.push(simpleMessage);
        //}

        // Handle complex array if present
       // if (Array.isArray(complex)) {
       //     complex.forEach(item => {
       //         if (item.short_answer !== "") {
       //             const complexMessage = {
       //                 role: "assistant",
       //                 short_answer: item.short_answer || "",
       //                 full_answer: item.full_answer || "",
       //                 citations: item.citations || [],
       //                 showFull: false,
       //                 showCitations: false,
       //                 url: url || false,
       //                 hideShortAnswer: false
       //             };
       //             newMessages.push(complexMessage);
       //         }
       //     });
       // }


        const LLmMessage = {
                role: "assistant",
                short_answer: answerText || "Error: No answer received.",
                full_answer: "",
                citations: [],
                showFull: false,
                showCitations: false,
                url: false,
                hideShortAnswer: false,
                timestamp: messageTimestamp
            };
        newMessages.push(LLmMessage);

        // Update state with all new assistant messages
        setMessages((prevMessages) => [...prevMessages, ...newMessages.map(m => ({ role: "assistant", content: m.short_answer }))]);
        setMessagesToDisplay((prevMessages) => [...prevMessages, ...newMessages]);

    } catch (error) {
        console.error("Error sending message:", error);
    } finally {
        setIsLoading(false);
    }
};

    function handleFeedback(index, event){
        const feedbackType = event.currentTarget.id;
        setActiveFeedback((prev = {}) => ({
            ...prev,
            [index]: prev?.[index] === feedbackType ? null : feedbackType,
        }));
        setFeedbackText("");
    }

    // time function is used to make it show a quick message of feedback reception
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function handleFeedbackSubmission(index, labelType, feedbackText="") {
        const currentTime = new Date();

        console.log('Feedback desejado (${activeFeedback}):', feedbackText);
        const chatPromptText = messagesToDisplay[index].short_answer;
        const messageTime = messagesToDisplay[index].timestamp || currentTime.toISOString();
        const feedback = { // This payload is then sent to the lambda function
            "sessionID": sessionCode,
            "chatPrompt": chatPromptText,
            "feedbackLabel": labelType,
            "feedbackText": feedbackText,
            "timeOfFeedback": currentTime.toISOString(),
            "timeOfMessage": messageTime,
        };

        console.log("Feedback to be sent: ",JSON.stringify(feedback));
        try {
        const response = await fetch(serverConfig.feedbackUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(feedback),
        });


        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log("Feedback sent successfully");
        
        } catch (error) {
            console.error("Error sending feedback:", error);
            // Handle error (show user notification, etc.)
            return; // Exit early on error
        }

        console.log("Feedback to be sent:", feedback);
        console.log("Path at feedback submission:", window.location.pathname);
        setActiveFeedback({});
        setFeedbackText("");
        //setTimeOfFeedback(null);
        setFeedbackReceived((prev) => ({
            ...prev,
            [index]: true,
        }));
        console.log("Feedback submitted for index:", index);
    }

    // Scroll to the bottom whenever is sent a new message
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    // Send the most recent message to the dynamoDB
    //useEffect(() => {
   //     if(messages.length === 0) return;
   //     const lastMessage = messages[messages.length - 1];
//
    //    const saveMessageToLambda = async () => {
 //           try {
 //               const response = await fetch('https://b6aqyj87xh.execute-api.eu-central-1.amazonaws.com/default/newChatBotHistoryLambdaHandler', {
 //                   method: 'POST',
 //                   headers: {
 //                       'Content-Type': 'application/json',
 //                   },
 //                   body: JSON.stringify({
 //                       SessionID: sessionCode,
 //                       owner_type: lastMessage.role,
 //                       message: lastMessage.content,
 //                       date: new Date().toISOString()
 //                   }),
 //       });


 //           if (!response.ok) {
 //               throw new Error(`Failed to save message history. HTTP error! status: ${response.status}`);
 //           }
 //           } catch (error) {
 //           console.error("Error saving message history:", error);
 //           }
 //       };
 //       saveMessageToLambda();
 //
 //   }, [messages])

    // Get the greeting message from the chatbot when the component mounts
    useEffect(() => {        
        const savedLang = localStorage.getItem("preferredLanguage");    
        if (selectedLanguage) {
            setSelectedLanguage(selectedLanguage);
        } else {
            const browserLang = navigator.language || navigator.userLanguage;
            let defaultLang = "en";

            if (browserLang.startsWith("pt")) {
                defaultLang = "pt";
            } else if (browserLang.startsWith("es")) {
                defaultLang = "es";
            } else {
                defaultLang = "en";
            }
            setSelectedLanguage(defaultLang);
            localStorage.setItem("preferredLanguage", defaultLang);
        }
    }, []);

    useEffect(() => {
        const fetchGreetingMessage = () => {
            try {
                const languageTranslations = translations[LANG_MAP[selectedLanguage] || selectedLanguage] || translations['english'];
                const response = languageTranslations.welcomeMessage;
                setGreetingMessage(response);
            } catch (error) {
                console.error("Error getting greeting message:", error);
            }
        };

        fetchGreetingMessage();
    }, [selectedLanguage]);


    // Handle pressing Enter key
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            if (e.shiftKey) {
                // Allow new line when Shift + Enter is pressed
                e.preventDefault(); // Prevent form submission
                setInput((prevInput) => prevInput + "\n");
            } else {
                // Send the message when Enter is pressed alone
                e.preventDefault();
                handleSend();
            }
        }
    };

    //
    const handleFullAnswerClick = (index, url, full_answer) => {
        if (url) {
            window.open(full_answer, "_blank");
        } else {
            setMessagesToDisplay(prevMessages =>
                prevMessages.map((msg, i) => {
                    if (i === index) {
                        return {
                            ...msg,
                            showFull: !msg.showFull,
                            hideShortAnswer: !msg.hideShortAnswer
                        };
                    }
                    return msg;
                })
            );
            // Scroll to bottom after expanding/collapsing answer
            setTimeout(() => {
                if (messagesEndRef.current) {
                    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
                }
            }, 0);
        }
    };


    return (
        <div className="chatbox">
            {/* Top Bar with Close Button */}
            <div className="chatbox-header">
                {/* SVG Icon */}
                <img src={navigatorIcon} alt="Step Icon" className="chatbox-icon" />

                {/* Title & Subtitle */}
                <div className="chatbox-text">
                    <span className="chatbox-title">{t.title}</span>
                    <div className="chatbox-subtitle">
                        <ReactMarkdown>{t.virtualAssistant}</ReactMarkdown>
                    </div>
                </div>
            </div>

            {/* Show chat history */}
            <div className="messages">
                {greetingMessage && (
                    <div className="message-box">
                        <img src={navigatorIcon} alt="Bot" className="assistant-icon" />
                        <div className="message-box-content">
                        <div className={"message assistant"}>
                            <ReactMarkdown
                                components={{
                                    p: ({ children }) => (
                                        <p style={{ whiteSpace: "pre-wrap", tabSize: 4 }}>
                                            {children}
                                        </p>
                                    ),
                                    li: ({ children }) => (
                                        <li style={{ whiteSpace: "pre-wrap", marginLeft: "1em" }}>
                                            {children}
                                        </li>
                                    ),
                                }}
                            >
                                {greetingMessage.replace(/\t/g, "    ")}
                            </ReactMarkdown>
                        </div>
                        </div>

                    </div>
                )}
                {messagesToDisplay.map((message, index) =>
                    message.role === "assistant" ? (
                        <div key={index} className="message-box">
                            <img src={navigatorIcon} alt="Bot" className="assistant-icon" />
                            <div className="message-box-content">
                            <div className={`message ${message.role}`}>
                                {!message.hideShortAnswer  && (
                                    <ReactMarkdown
                                        components={{
                                            p: ({ children }) => (
                                                <p style={{ whiteSpace: "pre-wrap", tabSize: 4 }}>{children}</p>
                                            ),
                                            li: ({ children }) => (
                                                <li style={{ whiteSpace: "pre-wrap", marginLeft: "1em" }}>
                                                    {children}
                                                </li>
                                            ),
                                        }}
                                    >
                                        {message.short_answer?.replace(/\t/g, "    ")}
                                    </ReactMarkdown>
                                )}

                                {/* Show full answer if toggled */}
                                {message.showFull && (
                                    <div>
                                        <ReactMarkdown
                                            components={{
                                                p: ({ children }) => (
                                                    <p style={{ whiteSpace: "pre-wrap", tabSize: 4 }}>{children}</p>
                                                ),
                                                li: ({ children }) => (
                                                    <li style={{ whiteSpace: "pre-wrap", marginLeft: "1em" }}>
                                                        {children}
                                                    </li>
                                                ),
                                            }}
                                        >
                                            {message.full_answer?.replace(/\t/g, "    ")}
                                        </ReactMarkdown>
                                    </div>
                                )}

                                {/* Show citations if toggled */}
                                {message.showCitations && message.citations.length > 0 && (
                                    <div style={{ marginTop: "1em" }}>
                                        <strong>Citations:</strong>
                                        <ul style={{ paddingLeft: "1.5em", marginTop: "0.5em" }}>
                                            {message.citations.map((citation, i) => (
                                                <li key={i}>
                                                    <ReactMarkdown
                                                        components={{
                                                            a: ({ node, ...props }) => (
                                                                <a {...props} target="_blank" rel="noopener noreferrer" />
                                                            ),
                                                            p: ({ children }) => (
                                                                <p style={{ display: "inline", whiteSpace: "pre-wrap" }}>
                                                                    {children}
                                                                </p>
                                                            ),
                                                        }}
                                                    >
                                                        {citation}
                                                    </ReactMarkdown>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Show button if full answer is hidden */}
                                {message.full_answer !== '' && (
                                    <button
                                        className="show-full-answer-btn"
                                        /* Check if full answer is an url or not */
                                        onClick={() => handleFullAnswerClick(index, message.url, message.full_answer)}
                                        style={{
                                            backgroundColor: "#007BFF",
                                            color: "white",
                                            border: "none",
                                            padding: "6px 12px",
                                            borderRadius: "4px",
                                            marginTop: "8px",
                                            marginRight: "8px",
                                            cursor: "pointer",
                                            width: "210px",
                                            height: "28px",
                                        }}
                                    >
                                        {message.url?
                                            t.description
                                            :
                                            message.hideShortAnswer?
                                                t.hideExtendedAnswer
                                                :
                                                t.showExtendedAnswer
                                        }
                                    </button>
                                )}
                                {/* Show citations button if hidden and citations exist */}
                                {message.citations.length > 0 && (
                                    <button
                                        className="toggle-citations-btn"
                                        onClick={() =>
                                            setMessagesToDisplay((prevMessages) =>
                                                prevMessages.map((msg, i) =>
                                                    i === index ? { ...msg, showCitations: !msg.showCitations } : msg
                                                )
                                            )
                                        }
                                        style={{
                                            backgroundColor: "#007BFF",
                                            color: "white",
                                            border: "none",
                                            padding: "6px 12px",
                                            borderRadius: "4px",
                                            marginTop: "8px",
                                            cursor: "pointer",
                                            width: "210px",
                                            height: "28px",
                                        }}
                                    >
                                        {message.showCitations ? t.hideCitations : t.showCitations}
                                    </button>
                                )}

                            </div>




                            {/* Feedback Section */}
                            {!feedbackReceived[index] ? (
                                <FeedbackLabels
                                    onSubmit={(selectedLabel, feedbackText) => {
                                            handleFeedbackSubmission(index, selectedLabel, feedbackText);
                                    }}
                                    translations={t}
                                    disabled={activeFeedback[index]}
                                />
                            ) : (
                                <div className="feedbackReceivedBox">
                                    {t.receivedFeedback}
                                </div>
                            )}
                            </div>
                        </div>
                    ) : (
                        // User message
                        <div key={index} className={`message ${message.role}`}>
                            <ReactMarkdown
                                components={{
                                    p: ({ children }) => (
                                        <p style={{ whiteSpace: "pre-wrap", tabSize: 4 }}>{children}</p>
                                    ),
                                    li: ({ children }) => (
                                        <li style={{ whiteSpace: "pre-wrap", marginLeft: "1em" }}>
                                            {children}
                                        </li>
                                    ),
                                }}
                            >
                                {message.content.replace(/\t/g, "    ")}
                            </ReactMarkdown>
                        </div>
                    )
                )}

                {/* Show the typing indicator only when waiting for response */}
                {isLoading && (
                    <div className="message-box">
                        <img src={navigatorIcon} alt="Bot" className="assistant-icon" />
                        <div className={`message assistant`}>
                            <LoadingMessage />
                        </div>
                    </div>
                )}

                {/* Invisible div to scroll to */}
                <div ref={messagesEndRef}></div>
            </div>

            {/* Input message area */}
            <div className="input-area">
                <textarea
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyPress}
                    placeholder={t.anyQuestions}
                    rows="1"
                />
                {/* Button to send a message */}
                <button
                    onClick={handleSend}
                    disabled={!input.trim() || isLoading} // Disable button when input is empty or during sending
                >
                    <i className="fas fa-arrow-up"></i>
                </button>
            </div>
        </div>
    );
};

export default ChatBox;
